import { api } from '../../shared/api/client';
import type {
  AdvancesDto,
  AdvancesQuery,
  BillingDto,
  BillingQuery,
  ContractorInvoicesDto,
  ContractorInvoicesQuery,
  TimesheetDto,
  TimesheetQuery,
} from './types';

/**
 * Decimais (`valor*`, `valorHora`, `totalValor`) podem chegar como string
 * do GeneXus. `adaptResponse` no BFF já normaliza decimais com
 * `/^-?\d+\.\d+$/`, então o front recebe number. Contadores `Num(4,0)`
 * (count, totalFaltas, etc.) chegam JSON number nativos.
 */

export async function getRelatorioTimesheet(query: TimesheetQuery): Promise<TimesheetDto> {
  const { data } = await api.get<{ data: TimesheetDto }>('/v1/reports/timesheet', {
    params: query,
  });
  return data.data;
}

export async function getRelatorioBilling(query: BillingQuery): Promise<BillingDto> {
  const { data } = await api.get<{ data: BillingDto }>('/v1/reports/billing', {
    params: query,
  });
  return data.data;
}

export async function getRelatorioContractorInvoices(
  query: ContractorInvoicesQuery,
): Promise<ContractorInvoicesDto> {
  const { data } = await api.get<{ data: ContractorInvoicesDto }>(
    '/v1/reports/contractor-invoices',
    { params: query },
  );
  return data.data;
}

export async function getRelatorioAdvances(query: AdvancesQuery): Promise<AdvancesDto> {
  const { data } = await api.get<{ data: AdvancesDto }>('/v1/reports/advances', {
    params: query,
  });
  return data.data;
}
